
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uitslagen",
      function () {
        return require("private-next-pages/uitslagen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uitslagen"])
      });
    }
  